import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

  export class v_QuoteEquipmentBus extends BaseBus
  {
      constructor(data: v_QuoteEquipmentBus = null) {
          super(data);
          if (data != null) {
              this.creationDate = DateFunctions.getDate(data.creationDate);
              this.insertDt = DateFunctions.getDate(data.insertDt);
              this.updateDt = DateFunctions.getDate(data.updateDt);
          }
      }
      CID(): any {
          return this.equipmentId;
      }
      setId(id: any) {
          this.equipmentId = id;
      }
      setParentId(id: any) {
          this.quoteId = id;
      }
      initialize(data: v_QuoteEquipmentBus) {
          super.initialize(data);
          try {
              this.creationDate = DateFunctions.getDate(data.creationDate);
              this.insertDt = DateFunctions.getDate(data.insertDt);
              this.updateDt = DateFunctions.getDate(data.updateDt);
          }
          catch {

          }

      }
      setFromForm(data: v_QuoteEquipmentBus) {
          super.setFromForm(data);
          let dateNow = DateFunctions.getDateNow();
          if (this.hasId) {
          }
          else {
              this.equipmentId = CommonFunctions.getGuid();
              this.creationDate = dateNow;
              this.insertDt = dateNow;
          }
          this.updateDt = dateNow; 

      }
      setBeforeSave() {
          this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
          this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
      }
      equipmentId: string;
      quoteId: string;
      manufacturerId: string;
      manufacturerTypeId: string;
      quoteEquipmentXREFId: any;
      model: string;
      serialNumber: string;
      notes: string;
      isOnDispatchQuote: boolean;
      isNewForQuote: boolean;
      systemId: string;
      barcode: string;
      manufacturerName: string;
      manufacturerTypeName: string;
      createdBy: string;
      creationDate: Date;
      insertUserId: any;
      insertDt: Date;
      updateUserId: any;
      updateDt: Date;
      isPrintable: boolean;
  }
